<template>
    <div class="footer">
        <div class="d-flex justify-center">
            <img class="logo" src="../assets/logo.png"/>
        </div>
        <div class="d-flex justify-center">
            <div class="info-text text-center">
                〒440-0837<br/>
                愛知県豊橋市三ノ輪町本興寺４１ ー １<br/>
                第１丸中ビル 2階<br/>
                TEL 0532-87-4333<br/>
                FAX 0532-87-4334<br/>
            </div>
        </div>
        <div class="map d-flex justify-center">
            <center>
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2756.6789859311625!2d137.40843249834364!3d34.74898572720437!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6004d2564811da0b%3A0x5ebf246445907038!2z44CSNDQwLTA4Mzcg5oSb55-l55yM6LGK5qmL5biC5LiJ44OO6Lyq55S65pys6IiI5a-6IOesrO-8keS4uOS4reODk-ODqw!5e0!3m2!1sja!2sjp!4v1584946577568!5m2!1sja!2sjp" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </center>
        </div>
        <div class="link d-flex justify-center">
            <a class="link-text" href="https://aichi-fk.jp">ホーム</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped>
    .footer {
        background-color:#474847;
        padding: 30px 0;
    }
    .logo {
        max-width: 90%;
        width: 430px;
    }
    .info-text {
        font-size: min(3vw, 15px);
        font-weight: 500;
        color: white;
        background-color: rgba(0,0,0,0);
        line-height: 1.8;
        margin-top: 10px;
    }
    .map {
        margin: 30px 0;
    }
    .link-text {
        font-size: 12px;
        font-weight: 500;
        color: white;
        border-left: 1px solid white;
        border-right: 1px solid white;
        text-decoration: none;
        padding:0 9.75px;
    }
</style>